<app-main-page>
  <app-issues-list></app-issues-list>
</app-main-page>
